import React, { useRef } from 'react';

function PharmacophoreScreeningModule({ onSubmit }) {
  const modelRef = useRef();
  const compoundRef = useRef();

  const handleSubmit = () => {
    const modelFile = modelRef.current.files[0];
    const compoundFile = compoundRef.current.files[0];
    if (!modelFile || !compoundFile) return alert("请上传药效团模型和候选分子文件");

    const formData = new FormData();
    formData.append('pharmModel', modelFile);
    formData.append('compoundFile', compoundFile);
    onSubmit('药效团筛选', formData, 'pharmacophore');
  };

  return (
    <div className="flex flex-col h-full">
      <input type="file" ref={modelRef} className="form-input" />
      <input type="file" ref={compoundRef} className="form-input mt-2" />
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">提交任务</button>
      </div>
    </div>
  );
}

export default PharmacophoreScreeningModule;

